































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api';
import * as validators from '@/utils/validator';
/**
 * 添加rg
 *
 * @author xiaokunyu
 * @date 01/11/2019
 */
interface Form {
    name: string;
    description: string;
    owner: string;
    icon: string;
}
const validateOwner: Function = (_rule, value, callback) => {
    if (!value) {
        return callback(new Error('负责人不能为空'));
    }
    return callback();
};
/**
 * 添加RG
 *
 * @author xiaokunyu
 * @date 01/11/2010
 */
@Component
export default class AddRgDialog extends Vue {
    @Prop({ default: false })
    visible: Boolean;
    @Prop({ default: false })
    isEdit: Boolean;
    @Prop({ default: false })
    isSpace: Boolean;
    @Prop()
    rgInfo: Form;

    userList: CommonTypes.UserInfoItem[] = [];
    show: Boolean = false;
    ruleCustom = {
        name: [{ validator: validators.validateName100, trigger: 'blur' }],
        owner: [{ validator: validateOwner, trigger: 'blur, change' }]
    };
    formCustom: Form = {
        name: '',
        description: '',
        owner: '',
        icon: '//s3plus.sankuai.com/v1/mss_4a5c70e8b289484393a22a82f4c3ed40/static-source/TT_logo.png'
    };
    btnLoading: Boolean = false;
    searchLoading: Boolean = false;
    imgUploading: boolean = false;

    $refs: any;
    @Watch('visible', { immediate: true })
    onShowChanged(val) {
        this.show = val;
        val && this.$refs.formCustom.resetFields();
        if (val && this.isEdit) {
            for (const key in this.formCustom) {
                this.formCustom[key] = this.rgInfo[key];
            }
        }
    }
    close() {
        this.$emit('update:visible', false);
    }
    async remoteMethod(query) {
        this.searchLoading = true;
        try {
            const res = await api.rgApi.searchUser({ keyword: query });
            this.userList = res.data.items as any;
        } catch (e) {
            this.userList = [];
            console.log(e);
        }
        this.searchLoading = false;
    }
    async submit() {
        if (this.btnLoading) {
            return;
        }
        interface AddRgParams {
            name: string;
            description: string;
            owner: string;
            icon: string;
            spaceId?: number;
        }
        interface EditRgParams extends AddRgParams {
            rgId: number;
        }
        this.$refs.formCustom
            .validate(async valid => {
                if (valid) {
                    this.btnLoading = true;
                    const params: AddRgParams = {
                        name: this.formCustom.name,
                        description: this.formCustom.description,
                        owner: this.formCustom.owner,
                        icon: this.formCustom.icon
                    };
                    if (this.isSpace) {
                        params.spaceId = parseInt(this.$route.params.id, 10);
                    }
                    if (this.isEdit) {
                        (params as EditRgParams).rgId = this.rgId;
                    }
                    try {
                        const res = this.isEdit
                            ? await api.rgApi.editRg(params as EditRgParams)
                            : this.isSpace
                            ? await api.spaceApi.addSpaceRg(params as Required<AddRgParams>)
                            : await api.rgApi.addRg(params);
                        const { code, data } = res;
                        if (code === 200) {
                            this.$mtd.message({
                                message: this.isEdit ? '编辑 RG 成功' : '添加 RG 成功',
                                type: 'success'
                            });
                            this.close();
                            this.$emit('success', data.id);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                    this.btnLoading = false;
                } else {
                    console.error('Fail!');
                }
            })
            .catch(e => e);
    }
    beforeUpload(file) {
        const name = file.name;
        const type = name.substr(name.lastIndexOf('.') + 1).toLowerCase();
        const imageType = ['png', 'jpg', 'jpeg'];
        if (imageType.indexOf(type) < 0) {
            this.$mtd.message.error('上传头像图片格式有误');
            return false;
        }
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            this.$mtd.message.error('上传头像图片大小不能超过 10MB');
        }
        return isLt10M;
    }
    handleUploadSuccess(res) {
        this.formCustom.icon = res.data.url;
        this.imgUploading = false;
    }
    handleUploadError() {
        this.imgUploading = false;
        this.$mtd.message.error('上传失败');
    }
    handleUploadProgress() {
        this.imgUploading = true;
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
